var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596",
    transform: "translate(-422 -568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 35,
    height: 35,
    rx: 17.5,
    transform: "translate(422 568)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock-1-svgrepo-com",
    transform: "translate(433.823 578.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M145.4,86.7h-8a4,4,0,0,1-4-4v-6a4.008,4.008,0,0,1,3-3.873V70.7a4,4,0,0,1,4-4h2a4,4,0,0,1,4,4v2.127a4.008,4.008,0,0,1,3,3.873v6A4,4,0,0,1,145.4,86.7Zm-8-12a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-6a2,2,0,0,0-2-2Zm1-2h6v-2a2,2,0,0,0-2-2h-2a2,2,0,0,0-2,2v2Zm3,10a1,1,0,0,1-1-1V80.432a2,2,0,1,1,2,0V81.7A1.008,1.008,0,0,1,141.4,82.7Z",
    transform: "translate(-135.4 -69.7)",
    fill: "#ff3535"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLight);
export default __webpack_public_path__ + "static/media/lock-light.43e0b697d1c9e88a47c897e011ec0edb.svg";
export { ForwardRef as ReactComponent };